import type { GeoJSONFeature } from '@tmapy/mapcore';
import { PREDEFINED_AREAS_SET_FEATURES } from './constants';

export type ActionSetPredefinedAreasFeatures = ReturnType<typeof actionSetPredefinedAreasFeatures>;

export const actionSetPredefinedAreasFeatures = (
  features: GeoJSONFeature[],
): { readonly type: typeof PREDEFINED_AREAS_SET_FEATURES; readonly payload: GeoJSONFeature[] } =>
  ({
    type: PREDEFINED_AREAS_SET_FEATURES,
    payload: features,
  }) as const;
